<template>
	<Popup
		v-model="selfDisplay"
		title="修改治疗仪"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label">机器ID</span>
				<el-input :value="mid" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">生产日期</span>
				<el-date-picker
					:value="createDate"
					disabled
					:editable="false"
					type="date"
					value-format="yyyy-MM-dd"
				>
				</el-date-picker>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">生产批号</span>
				<el-input :value="createNumber" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">型号</span>
				<el-input :value="model" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">芯片ID</span>
				<el-input :value="chipId" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">版本</span>
				<el-input :value="version" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>出售日期</span>
				<el-date-picker
					v-model="sellDate"
					:editable="false"
					type="date"
					placeholder="出售日期"
					value-format="yyyy-MM-dd"
				>
				</el-date-picker>
			</div>
			<div class="base_tip"><template v-if="sellDateTip"><i class="b_icon"></i>请选择出售日期</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>省市区</span>
				<VDistpicker :province="provinceName" :city="cityName" :area="areaName" @province="handleAddrProvinceSelect" @city="handleAddrCitySelect" @area="handleAddrAreaSelect"></VDistpicker>
			</div>
			<div class="base_tip"><template v-if="addrTip"><i class="b_icon"></i>请选择省市区</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>所属机构</span>
				<el-select v-model="oid" placeholder="请选择" style="width: 100%;">
					<el-option
						v-for="v in allOrganization"
						:key="v.id"
						:label="v.name"
						:value="v.id">
					</el-option>
				</el-select>
			</div>
			<div class="base_tip"><template v-if="oTip"><i class="b_icon"></i>请选择所属机构</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>剩余用量</span>
				<el-input v-model="remain" placeholder="剩余用量"></el-input>
			</div>
			<div class="base_tip"><template v-if="remainTip"><i class="b_icon"></i>请输入剩余用量</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>计费方式</span>
				<el-select v-model="billing" placeholder="计费方式" style="width: 100%;">
					<el-option :value="1" label="无限"></el-option>
					<el-option :value="2" label="包月"></el-option>
					<el-option :value="3" label="计次"></el-option>
					<el-option :value="4" label="计时"></el-option>
				</el-select>
				<div v-if="billing == 2" style="margin-top: 20px;line-height: 36px;">
					开始时间
					<el-date-picker
						v-model="billingStartDate"
						:editable="false"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="开始时间"
						@change="handleBillingDateChange"
					>
					</el-date-picker>
				</div>
				<div v-if="billing == 2" style="margin-top: 20px;line-height: 36px;">
					结束时间
					<el-date-picker
						v-model="billingEndDate"
						:editable="false"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="结束时间"
						@change="handleBillingDateChange"
					>
					</el-date-picker>
				</div>
				<div v-if="billing == 3" style="margin-top: 20px;line-height: 36px;">
					<el-input v-model="billingNum" style="width: 200px;"></el-input>
					次
				</div>
				<div v-if="billing == 4" style="margin-top: 20px;line-height: 36px;">
					<el-input v-model="billingMinute" style="width: 200px;"></el-input>
					分钟
				</div>
			</div>
			<div class="base_tip"><template v-if="billingTip"><i class="b_icon"></i>计费方式输入不合法</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: Number,
				default: -1
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				mid: '',
				createDate: '',
				createNumber: '',
				model: '',
				chipId: '',
				version: '',
				sellDate: '',
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: '',
				oid: '',
				remain: '',
				billing: 1,
				billingStartDate: '',
				billingEndDate: '',
				billingNum: '',
				billingMinute: '',
				sellDateTip: false,
				addrTip: false,
				oTip: false,
				remainTip: false,
				billingTip: false
			}
		},
		computed: {
			...mapState([
				'allOrganization'
			])
		},
		methods: {
			// 新增地址省份选择
			handleAddrProvinceSelect(data) {
				this.provinceName = data.code ? data.value : '';
				this.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 新增地址城市选择
			handleAddrCitySelect(data) {
				this.cityName = data.code ? data.value : '';
				this.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 新增地址区域选择
			handleAddrAreaSelect(data) {
				this.areaName = data.code ? data.value : '';
				this.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换时间
			handleBillingDateChange() {
				this.compareDate();
			},
			// 比较开始时间和结束时间
			compareDate() {
				if (this.billingStartDate && this.billingEndDate) {
					var startDate = new Date(this.billingStartDate).getTime(),
						endDate = new Date(this.billingEndDate).getTime();
					if (endDate < startDate) {
						this.endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			},
			// 获取详情数据
			getData() {
				const that = this;
				that.loading = true;
				Api.getIFDetail(that.id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.mid = res.data.data.machineId;
						that.createDate = res.data.data.productionDate;
						that.createNumber = res.data.data.productionSerial;
						that.model = res.data.data.modelName;
						that.chipId = res.data.data.chipId;
						that.version = res.data.data.swVersion;
						that.sellDate = res.data.data.saleDate;
						that.provinceName = res.data.data.provinceName;
						that.cityName = res.data.data.cityName;
						that.areaName = res.data.data.areaName;
						that.oid = res.data.data.optId;
						that.remain = res.data.data.remainInfo;
						that.billing = res.data.data.feeType;
						that.billingStartDate = res.data.data.monthStartTime || '';
						that.billingEndDate = res.data.data.monthEndTime || '';
						that.billingNum = res.data.data.timeCount || '';
						that.billingMinute = res.data.data.minuteCount || '';
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击修改
			handleUpdateClick() {
				if (!this.sellDate) {
					this.sellDateTip = true;
					return false;
				} else {
					this.sellDateTip = false;
				}
				if (!this.areaCode) {
					this.addrTip = true;
					return false;
				} else {
					this.addrTip = false;
				}
				if (!this.oid) {
					this.oTip = true;
					return false;
				} else {
					this.oTip = false;
				}
				if (!this.remain.trim()) {
					this.remainTip = true;
					return false;
				} else {
					this.remainTip = false;
				}
				if (this.billing == 2) {
					if (!this.billingStartDate || !this.billingEndDate) {
						this.billingTip = true;
						return false;
					}
				}
				if (this.billing == 3) {
					if (!this.positiveReg.test(this.billingNum)) {
						this.billingTip = true;
						return false;
					}
				}
				if (this.billing == 4) {
					if (!this.floatReg.test(this.billingNum)) {
						this.billingTip = true;
						return false;
					}
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					id: that.id,
					machineId: that.mid,
					chipId: that.chipId,
					productionDate: that.createDate,
					productionSerial: that.createNumber,
					saleDate: that.sellDate,
					areaId: that.areaCode,
					optId: that.oid,
					userType: 1,
					modelName: that.model,
					swVersion: that.version,
					optionJson: '',
					feeType: that.billing,
					remainInfo: that.remain,
					monthStartTime: that.billingStartDate,
					monthEndTime: that.billingEndDate,
					provinceId: that.provinceCode,
					cityId: that.cityCode,
					timeCount: that.billingNum,
					minuteCount: that.billingMinute
				};
				Api.updateIF(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getData();
				} else {
					this.loading = false;
					this.mid = '';
					this.createDate = '';
					this.createNumber = '';
					this.model = '';
					this.chipId = '';
					this.version = '';
					this.sellDate = '';
					this.provinceName = '';
					this.cityName = '';
					this.areaName = '';
					this.oname = '';
					this.remain = '';
					this.billing = 1;
					this.billingStartDate = '';
					this.billingEndDate = '';
					this.billingNum = '';
					this.billingMinute = '';
					this.sellDateTip = false;
					this.addrTip = false;
					this.oTip = false;
					this.remainTip = false;
					this.billingTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
